import { render, staticRenderFns } from "./AssingBreakfast.vue?vue&type=template&id=23886cea"
import script from "./AssingBreakfast.vue?vue&type=script&lang=js"
export * from "./AssingBreakfast.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports